"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function(input) {
          this.state = {
              page: null
            };

          GState.bind(this, [
              "skeleton"
            ]);

          if (this.state.skeleton) {
            this.state.page = this.state.skeleton.pages[input.routeTo];
          }
        },
        onTrigger: function() {
          this.emit("trigger");
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/EmptyList.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    Bx_template = require("../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("0fa06b"),
    marko_node0 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "font-medium-3",
        style: "padding:0 15%"
      },
    marko_node3 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "btn btn-primary btn-lg"
      };

function render(input, out, __component, component, state) {
  var data = input;

  get_context_tag({
      __from: index_template,
      renderBody: function(out, { page }) {
        out.be("div", {
            "class": "placeholder text-center",
            style: marko_styleValue({
                padding: "5% 25%"
              })
          }, "0", component, null, 1);

        Bx_tag({
            type: (input.icon || page.icon) || "bx-search",
            class: "text-muted font-large-4"
          }, out, __component, "1");

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        if (input.message) {
          out.be("p", marko_attrs0, "5", component);

          Locale_tag({
              text: input.message
            }, out, __component, "6");

          out.ee();
        }

        if (input.routeTo && state.page) {
          out.n(marko_node3, component);

          route_link_tag({
              href: state.page.path,
              class: "btn btn-primary btn-lg",
              renderBody: function(out) {
                Locale_tag({
                    text: state.page.title
                  }, out, __component, "9");
              }
            }, out, __component, "8");
        } else if (input.trigger) {
          out.be("button", marko_attrs1, "10", component, null, 0, {
              onclick: __component.d("click", "onTrigger", false)
            });

          Locale_tag({
              text: input.trigger
            }, out, __component, "11");

          out.ee();
        }

        out.ee();
      }
    }, out, __component, "12");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
